import {useQuery} from 'react-query';
import getDetailLabCard from '.';

const useGetDetailLabCard = (guid: string) => {
  const {data, isLoading} = useQuery(['lab-detail', guid], () =>
    getDetailLabCard(guid),
  );

  return {labDetailData: data, isLoading};
};

export default useGetDetailLabCard;
